<template>
	<div class="user flex main other_main">
		<asiden :asideData="asideList"></asiden>
		<div class="main_r">
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
import asiden from "../layout/aside/aside.vue";
export default {
	components: { asiden },
	name: "",
	data() {
		return {
			asideList: [
				{
					title: "推荐banner管理",
					icon: "",
					router: "/recommend/bannerlist",
					permissions: 601,
				},
				{
					title: "活动置顶管理",
					icon: "",
					router: "/recommend/eventtop",
					permissions: 603,
				},
				{
					title: "AMA管理",
					icon: "",
					router: "/recommend/amalist",
					permissions: 601,
				},
				{
					title: "首页金刚位管理",
					icon: "",
					router: "/recommend/homeClicklist",
					permissions: 601,
				},
			],
		};
	},
	mounted() {
		const role_permissions = this.$store.state.user.user.role_permissions; // 假设格式是 "100,200,300"
		if (role_permissions) {
			const permissionArray = role_permissions.split(",").map(Number); // 转换为数字数组
			this.asideList = this.asideList.filter((item) =>
				permissionArray.includes(item.permissions),
			);
		}
	},
};
</script>

<style scoped></style>
